<div class="prev"></div>
<div class="slide"></div>
<div class="next"></div>
